<template>
  <div>
    <!-- header -->
    <head-menu></head-menu>

    <!-- banner -->
    <div class="page-head">
      <img src="@/common/imgs/news.jpg" alt="">
    </div>

    <!-- content -->
    <div class="news-newslist">
      <div class="intro-title" style="height: auto;">
        <span>
          <h2 style="float: inherit;">华剑股份高新产业研制厂区</h2>
        </span>
      </div>
      <div class="intro-detail">
        <div class="industrial-park" v-html="content"></div>
      </div>
    </div>
    <!-- 回到顶部 -->
    <el-backtop></el-backtop>
    <!-- footer -->
    <foot-link></foot-link>

    <router-view></router-view>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer'
  import axios from 'axios'
  import global_msg from '@/common/js/global.js'

  export default {
    name: 'Detail',
    data() {
      return {
        content: ''
      }
    },
    mounted() {
      // 请求深汕产业园介绍
      axios.get(global_msg.baseUrl + 'companyOfficialWebsite/findByAll?sendType=深汕产业园').then((response) => {
        this.content = response.data.subject.result[0].content;
      });
    },
    methods: {

    },
    components: {
      'head-menu': Header,
      'foot-link': Footer
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/IndustrialPark.vue